<p>
  Je gaat nu {{ selection.length }} Leden van status laten veranderen.
  <b
    >Let op!: Deze leden verliezen het account wat bij ze hoort bij verandering
    naar de status 'oud-lid' of 'oud-extern'</b
    >
  </p>
  <mat-form-field>
    <mat-label>Nieuwe Status</mat-label>
    <mat-select [(ngModel)]="selected">
      @for (status of statusTypes; track status) {
        <mat-option [value]="status">
          {{ status.value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onDismiss()">Annuleer</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">
      Bevestig
    </button>
  </mat-dialog-actions>
